export class PermissionsScreen {

    public manage?: boolean;

    public read?: boolean;
   
    public add?: boolean;

    public edit?: boolean;

    public delete?: boolean;

    public export?: boolean;

    // REQUISITIONS PERMISSIONS
    public generate?: boolean;

    public authorizeDeptoHead?: boolean;

    public authorizeFinances?: boolean;
    
    public generatePurchaseOrder?: boolean;

    constructor(source: Partial<PermissionsScreen>) {
        Object.assign(this, source);
    }

}